"use client";
import React from "react";

// local component imports
import Skeleton from "../skeleton";
/**
 * HomeSkeleton renders a responsive loading placeholder for the dynamic home page.
 * Mirrors the visual structure of both mobile and desktop home layouts.
 * @returns {React.ReactElement} The home page skeleton loader.
 */
const HomeSkeleton = () => {
  return (
    <div className="bg-white w-full overflow-hidden px-[15px] pt-[16px]">
      {/* Hero banner */}
      <Skeleton variant="rounded" animation="pulse" customStyle={{ height: "180px", width: "100%" }} />

      {/* Category pills */}
      <div className="mt-[24px] flex gap-[8px] overflow-hidden">
        {Array.from({ length: 4 }, (_, i) => (
          <div key={i} className="flex flex-shrink-0 flex-col items-center gap-[8px]">
            <Skeleton variant="rounded" animation="pulse" customStyle={{ height: "100px", width: "100px" }} />
            <Skeleton variant="rounded" animation="pulse" customStyle={{ height: "12px", width: "64px" }} />
          </div>
        ))}
      </div>

      {/* Section title */}
      <div className="mt-[24px]">
        <Skeleton variant="rounded" animation="pulse" customStyle={{ height: "20px", width: "160px" }} />
      </div>

      {/* 2-column product grid — 2 rows */}
      {Array.from({ length: 2 }, (_, rowIdx) => (
        <div key={rowIdx} className="mt-[12px] grid grid-cols-2 gap-[12px]">
          {Array.from({ length: 2 }, (_, colIdx) => (
            <div key={colIdx} className="flex flex-col gap-[8px]">
              <Skeleton variant="rounded" animation="pulse" customStyle={{ height: "160px", width: "100%" }} />
              <Skeleton variant="rounded" animation="pulse" customStyle={{ height: "14px", width: "100%" }} />
              <Skeleton variant="rounded" animation="pulse" customStyle={{ height: "14px", width: "75%" }} />
              <Skeleton variant="rounded" animation="pulse" customStyle={{ height: "12px", width: "50%" }} />
            </div>
          ))}
        </div>
      ))}

      {/* Section title */}
      <div className="mt-[24px]">
        <Skeleton variant="rounded" animation="pulse" customStyle={{ height: "20px", width: "192px" }} />
      </div>

      {/* Horizontal scroll cards */}
      <div className="mt-[12px] flex gap-[12px] overflow-hidden">
        {Array.from({ length: 3 }, (_, i) => (
          <div key={i} className="flex w-[140px] flex-shrink-0 flex-col gap-[8px]">
            <Skeleton variant="rounded" animation="pulse" customStyle={{ height: "140px", width: "140px" }} />
            <Skeleton variant="rounded" animation="pulse" customStyle={{ height: "12px", width: "100%" }} />
            <Skeleton variant="rounded" animation="pulse" customStyle={{ height: "12px", width: "66%" }} />
          </div>
        ))}
      </div>

      {/* Section title */}
      <div className="mt-[24px]">
        <Skeleton variant="rounded" animation="pulse" customStyle={{ height: "20px", width: "144px" }} />
      </div>

      {/* Bottom 2-column grid */}
      <div className="mb-[24px] mt-[12px] grid grid-cols-2 gap-[12px]">
        {Array.from({ length: 2 }, (_, i) => (
          <div key={i} className="flex flex-col gap-[8px]">
            <Skeleton variant="rounded" animation="pulse" customStyle={{ height: "120px", width: "100%" }} />
            <Skeleton variant="rounded" animation="pulse" customStyle={{ height: "12px", width: "100%" }} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomeSkeleton;
